
<!-- TABELA -->
<nz-table
  [nzData]="logs"
  [nzLoading]="loading"
  [nzFrontPagination]="false"
  [nzTotal]="total"
  nzSize="small" 
  [nzBordered]="true"
  [nzPageIndex]="pageIndex"
  [nzPageSize]="pageSize"
  [nzTableLayout]="'fixed'"
  (nzQueryParams)="onQueryParamsChange($event)" 
  [nzScroll]="{ y: 'calc(100vh - 415px)'}"
  #nzTable
>
  <thead>
    <tr>
      <th nzWidth="60px"></th>
      <th nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="_id">{{'agentBuilder.id'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible._id"
          (nzVisibleChange)="onFilterVisibleChange('_id', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuTexto">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="REQUESTID">{{'agentBuilder.requestId'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.REQUESTID"
          (nzVisibleChange)="onFilterVisibleChange('REQUESTID', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuTexto">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="SESSIONID">{{'agentBuilder.sessionId'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.SESSIONID"
          (nzVisibleChange)="onFilterVisibleChange('SESSIONID', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuTexto">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="IDHOOK">{{'agentBuilder.idhook'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.IDHOOK"
          (nzVisibleChange)="onFilterVisibleChange('IDHOOK', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuNumber">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="INTIME">{{'agentBuilder.inTime'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.INTIME"
          (nzVisibleChange)="onFilterVisibleChange('INTIME', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuDate">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter nzWidth="100px" nzShowSort [nzSortFn]="true" nzColumnKey="STATUS">{{'agentBuilder.status'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.STATUS"
          (nzVisibleChange)="onFilterVisibleChange('STATUS', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuTexto">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter  nzWidth="100px" nzShowSort [nzSortFn]="true" nzColumnKey="DURATION">{{'agentBuilder.duration'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.DURATION"
          (nzVisibleChange)="onFilterVisibleChange('DURATION', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuNumber">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
    </tr>
  </thead>

  <tbody>
    @for (data of nzTable.data; track data._id) {
    <tr>
      <td [nzExpand]="expandSet.has(data._id)" (nzExpandChange)="onExpandChange(data._id, $event)"></td>
      <td>{{ data._id }}</td>
      <td>{{ data.REQUESTID }}</td>
      <td>{{ data.SESSIONID }}</td>
      <td>{{ data.IDHOOK }}</td>
      <td>{{ data.INTIME | date:'yyyy-MM-dd HH:mm:ss' }}</td>
      <td>{{ data.STATUS }}</td>
      <td>{{ data.DURATION }}</td>
    </tr>
    <tr [nzExpand]="expandSet.has(data._id)">
        <div class="expand-log-container">
          <div class="expand-log-section">
            <label class="expand-log-label">{{'agentBuilder.REQUESTHOOK' | translateTA}}</label>
            <json-viewer [json]="parseData(data.REQUESTHOOK)" [startFold]="false" class="expanded-log"></json-viewer>
          </div>
          <div class="expand-log-section">
            <label class="expand-log-label">{{'agentBuilder.DATAMID' | translateTA}}</label>
            <json-viewer [json]="parseData(data.DATAMID)" [startFold]="false" class="expanded-log"></json-viewer>
          </div>
          <div class="expand-log-section">
            <label class="expand-log-label">{{'agentBuilder.RESPONSEHOOK' | translateTA}}</label>
            <json-viewer [json]="parseData(data.RESPONSEHOOK)" [startFold]="false" class="expanded-log"></json-viewer>
          </div>
        </div>
    </tr>
     }
  </tbody>
</nz-table>



<nz-dropdown-menu #menuTexto="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchData[activeColumnKey]" >
          <button nz-button nzSize="small" nzType="primary" (click)="search(activeColumnKey)" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset(activeColumnKey)" class="search-button">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>
<nz-dropdown-menu #menuNumber="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <input type="number" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchData[activeColumnKey]" >
          <button nz-button nzSize="small" nzType="primary" (click)="search(activeColumnKey)" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset(activeColumnKey)" class="search-button">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>
<nz-dropdown-menu #menuDate="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <nz-date-picker
            [ngModel]="activeDateValue"
            (ngModelChange)="onDateSelected($event, activeColumnKey)"
            [style.width.%]="100"
            [nzShowTime]="true"
            [nzFormat]="'yyyy-MM-dd HH:mm:ss'"
            [nzSize]="'default'"
            nzShowToday
            nzShowNow>
          </nz-date-picker>
          <button nz-button nzSize="small" nzType="primary" (click)="search(activeColumnKey)" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset(activeColumnKey)" class="search-button">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>
